import React, { useEffect, useState } from 'react';
import api from '../services/api';

const ConsultantList = () => {
  const [consultants, setConsultants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      setError('');
      try {
        // fetch all users and derive consultants (include Admin as consultant)
        const res = await api.get('/users/list');
        const all = res.data || [];
        const cons = all.filter(u => {
          const role = String(u.role || '').toLowerCase();
          return role === 'consultant' || role === 'admin';
        });
        const withAssigned = cons.map((c) => {
          const assigned = all.filter(u => Number(u.consultant_id) === Number(c.id));
          return { ...c, assignedUsers: assigned };
        });
        setConsultants(withAssigned);
      } catch (err) {
        console.error('Failed to load consultants', err);
        setError(err?.response?.data?.message || 'Failed to load consultants');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading) return <div>Loading consultants...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!consultants.length) return <div>No consultants found.</div>;

  const renderUserNames = (assigned) => {
    if (!assigned || assigned.length === 0) return '-';
    const names = assigned.map(u => u.name || u.email || `#${u.id}`);
    if (names.length <= 3) return names.join(', ');
    const first = names.slice(0, 3).join(', ');
    return `${first} (+${names.length - 3} more)`;
  };

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #eee' }}>SL No</th>
          <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #eee' }}>Name</th>
          <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #eee' }}>Mobile Number</th>
          <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #eee' }}>No of user</th>
          <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #eee' }}>User Name</th>
        </tr>
      </thead>
      <tbody>
        {consultants.map((c, idx) => (
          <tr key={c.id} style={{ borderBottom: '1px solid #f6f6f6' }}>
            <td style={{ padding: 8 }}>{idx + 1}</td>
            <td style={{ padding: 8, fontWeight: 700 }}>{c.name || c.email}</td>
            <td style={{ padding: 8 }}>{c.mobile || c.registered_mobile || '-'}</td>
            <td style={{ padding: 8 }}>{(c.assignedUsers || []).length}</td>
            <td style={{ padding: 8 }}>{renderUserNames(c.assignedUsers)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ConsultantList;